import { css } from 'linaria';
import { globalOverlay } from 'styles/z-indexs';

export const hintWrapper = css`
  & > div:last-child > div {
    z-index: ${globalOverlay};
    border-radius: var(--rounding-l) !important;
    background: var(--background-primary);
    box-shadow: var(--box-shadow-m);
    filter: none;

    & > div:first-child {
      background: var(--background-primary);
    }
  }
`;
